import {useState} from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import CircledIcon from '../../../components/CircledIcon';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import GenericCard from '../../../components/GenericCards/GenericCards';
import Label from '../../../components/Label/Label';
import IconButton from '../../../components/IconButton';
import PopoverWithLinks from '../../widgets/PopoverLinks/PopoverLinks';


const DisabilityBenefits = () => {
  const [showDetails, setShowDetails] = useState<boolean>(false);

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  return (
    <Container className={'px-0'}>
      <Row className={'mt-8'}>
          <Col className={'col-12 col-lg-6'}>
              <h6 className="text-20 pb-0 mb-0">Long-Term Disability Coverage</h6>
          </Col>
      </Row>
      <Row className={'mt-8'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div className="d-flex">
                <CircledIcon
                  icon={light('heart-pulse')}
                  iconClassName="left-icon"
                  variant="icon-emphasized"
                />
              
              <div className="ms-4">
                <h5>Long-Term Disability Coverage</h5>
              </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <IconButton
                  variant="secondary-shadow"
                  icon={light('circle-info')}
                  onMouseDown={toggleDetails}
                  style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                />
                <Label
                  className="d-none d-lg-flex px-4"
                  style={{ color: '#54626A', cursor: 'pointer' }}
                  onMouseDown={toggleDetails}
                >
                  Benefits Info
                </Label>
              </div>
            </div>
            <Container className={'px-0 py-0 mt-10'}>
            <Row className={`expandable-wrapper ${showDetails ? 'open' : ''}`}>
              <div className="w-100 justify-content-center">

              <Card
                bg={'blue'}
                key={'Primary'}
                text={'white'}
                style={{ width: '18rem' }}
                className="bg-primary w-100 mb-12"
              >
                <Card.Body>
                  <Card.Text>
                    <ul>
                      <li>If you are not in active employment status, coverage may be added only upon your return to active status.</li>
                      <li>Premiums are based on your age; therefore, your birthday may cause your premiums to increase during the year. That means you may enroll at one premium at this time and have a change to your premium on your birthday if your age crosses a five-year age bracket (your new age will end in a zero or a five).</li>

                    </ul>

                  </Card.Text>
                </Card.Body>
              </Card>

              </div>
            </Row>
              {/* Table head */}
              <Row className={'d-none d-lg-flex mt-0 pb-5 border-bottom-light-gray-2px'}>
                <Col lg={6}>
                  <div className={'d-flex align-items-center'}>Long-Term Disability Coverage</div>
                </Col>                
                <Col lg={3}>
                  <div className={'d-flex'}></div>
                </Col>
                <Col lg={3} className="text-center">
                Per-pay-period
                </Col>
          
 
              </Row>

 
              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={6} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>50% Coverage (Average Pre-Disability Earnings: $0)</span></div></div>
                 </Col>
                <Col lg={3} className="text-end py-5">
                    <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                
                </Col>
                <Col lg={3} className="py-10 text-center bg-primary text-white">
                    $0.00
                </Col>
              </Row>
 
 
            </Container>
          </GenericCard>
        </Col>
      </Row>
    </Container>
  )
}

export default DisabilityBenefits